<template lang="pug">
div.color-picker-wrap(v-observe-visibility="visibilityChanged")
  v-label(v-if="label") {{ label }}

  div.swatch-wrap
    div.color-swatch(@click="showPicker = !showPicker" :style="{ backgroundColor: value }")
    template(v-if="showPicker")
      div.picker-backdrop(@click="showPicker = false")
      div.picker-popup
        chrome(:value="value" @input="emitOnlyHex")
</template>

<script>
  import { Chrome } from 'vue-color'

  export default {
    props: ["value", "label"],

    data() {
      return {
        showPicker: false
      }
    },

    components: { Chrome },

    methods: {
      emitOnlyHex(color) {
        this.$emit("input", color.hex)
      },

      visibilityChanged(visible) {
        if(!visible) {
          this.showPicker = false
        }
      }
    }
  }
</script>

<style>
  .color-swatch {
    width: 50px;
    height: 50px;
    cursor: pointer;
    border: gray 2px dashed;
  }

  .picker-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 300;
  }

  .swatch-wrap {
    position: relative;
    display: block;
  }

  .picker-popup {
    position: absolute;
    z-index: 301;
    top: 0;
    left: 0;
  }
</style>
